import { Dialog, DialogContent, CircularProgress, DialogTitle, DialogActions, Button, Box } from '@mui/material';
import { FormInput } from 'components/input/hook-form';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { decodeHashId } from 'lib/helpers/hasher';
import Cookies from 'universal-cookie';
import config from 'config';
import { WorkCategoryRequestBody } from 'lib/api/admin/adminWorkCategoryApi';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { DepartmentRequestBody, useCreateDepartmentMutation } from 'lib/api/admin/adminDepartmentApi';
import { SubCompanyRequestBody } from 'lib/api/admin/adminSubCompanyApi';

interface ICreateDepartmentDialogProps {
    open: boolean;
    handleClose: () => void;
}

const CreateDepartmentDialog = ({ open, handleClose }: ICreateDepartmentDialogProps) => {
    const cookies = new Cookies();
    const [createDepartment] = useCreateDepartmentMutation();
    const initialFormData: DepartmentRequestBody = {
        name: '',
        company_id: +decodeHashId(cookies.get(config.cookieCompanyId))
    };
    const { handleSubmit, control, reset, setValue } = useForm({
        defaultValues: initialFormData,
        mode: 'onSubmit',
        resolver: yupResolver(
            yup
                .object({
                    name: yup.string().required('*Name is required')
                })
                .required()
        )
    });
    const onSubmit = async (data: SubCompanyRequestBody) => {
        setLoading(true);
        await createDepartment(data)
            .unwrap()
            .then((e) => {
                setLoading(false);
                withReactContent(Swal).fire('Sukses', 'Berhasil menambahkan data!', 'success');
            })
            .catch((error) => {});
        reset.apply(initialFormData);
        setLoading(false);
        handleClosee();
    };

    const [isLoading, setLoading] = useState(false);
    const handleClosee = (event?: any, reason?: any) => {
        if (!isLoading) {
            handleClose();
        }
        if (reason && reason == 'backdropClick') return;
        handleClose();
    };
    return (
        <Dialog open={open} onClose={handleClosee}>
            <form onSubmit={handleSubmit(onSubmit)}>
                {isLoading ? (
                    <DialogContent>
                        <CircularProgress />
                    </DialogContent>
                ) : (
                    <div>
                        <DialogTitle variant="h3">Create Department</DialogTitle>
                        <DialogContent>
                            <Box sx={{ mt: 20 }}>
                                <FormInput control={control} label="Name" type="text" name="name" />
                            </Box>
                        </DialogContent>
                        <DialogActions>
                            <Button size="large" type="submit">
                                Create
                            </Button>
                        </DialogActions>
                    </div>
                )}
            </form>
        </Dialog>
    );
};

export default CreateDepartmentDialog;
